import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import CategoryTree from './CategoryTree';

interface MoveNoteSelectionModaProps {
  isVisible: boolean;
  selectedCategoryId: number;
  onCancel: () => void;
  onMove: (id: number, categoryBreadcrumb: string) => void;
  modalTitle?: string;
}

const styles = {
  tree: {
    moveModal: {
      treeContainer: 'max-h-[400px] overflow-y-auto border border-[#048ba8] rounded-lg p-4'
    }
  }
};

export const MoveNoteSelectionModal: React.FC<MoveNoteSelectionModaProps> = ({
  isVisible,
  selectedCategoryId,
  onCancel,
  onMove,
  modalTitle = 'Move Note',
}) => {

  const [selectedParentId, setSelectedParentId] = useState<number>(selectedCategoryId);
  const [categoryBreadcrumb, setCategoryBreadcrumb] = useState<string>('');

  return (
    <Modal
      title={modalTitle}
      open={isVisible}
      onCancel={onCancel}
      footer={null}
    >
      <div className="mt-4 space-y-4">
        <p className="text-[#0b1d51] dark:text-white">
          Select where to move your note
        </p>
        <div className={styles.tree.moveModal.treeContainer}>
          <CategoryTree
            onSelectCategory={(categoryId, categoryBreadcrumb) => {
              setSelectedParentId(categoryId);
              setCategoryBreadcrumb(categoryBreadcrumb);
            }}
            showActions={false}
            selectedCategoryId={selectedCategoryId}
            isMoveNoteModal={true}
          />
        </div>
      </div>
      <div className="mt-4 flex justify-end gap-2">
        <Button onClick={onCancel} className="border-[#048ba8] text-[#048ba8] hover:text-[#0b1d51] hover:border-[#0b1d51]">
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={() => onMove(selectedParentId, categoryBreadcrumb)}
          className="bg-[#d64933] hover:bg-[#f4d35e] border-none text-white"
        >
          Move
          </Button>
      </div>
    </Modal>
  );
};

export default MoveNoteSelectionModal;
